var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"name":_vm.defaultName,"mode":"passive","rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('b-form-group',{attrs:{"description":_vm.description,"label":_vm.label,"label-for":_vm.id}},[_c('cleave',_vm._g(_vm._b({staticClass:"form-control",class:errors.length > 0 ? 'is-invalid' : '',attrs:{"name":_vm.name,"id":_vm.id,"raw":true,"options":{
        numeral: true,
        numeralIntegerScale: 12,
        numeralThousandsGroupStyle: 'thousand',
      }}},'cleave',_vm.$attrs,false),_vm.$listeners)),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(errors[0]))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }